/* CB-CUSTOM 2026-10-31 TAC - Til dig (Copenhagen Bamboo), samme motor som bt-tildig.js.
 * Michael 31/10: personlige "Passer godt sammen med", "Anbefalinger til dig", "Udvalgte favoritter til dig",
 * "Udvalgte tilbud til dig" på produktside og forside, herre/dame efter kunden, og "total udbyg search".
 *
 * Alt regnes ud her i kundens browser ud fra bt-tildig-data.json (varer + hvad der købes sammen, ingen kundedata).
 * Kundens historik ligger i browseren (localStorage). Med cookie-samtykke sendes klik/visninger (tilfældigt id) til motoren.
 * Produktkortene hentes fra temaet selv (sections/bt-tildig-kort), så de ser ud som resten af butikken.
 */
(function () {
  'use strict';
  var C = window.TAC_TILDIG;
  if (!C || window.__tacTildig) return;
  window.__tacTildig = true;

  var NOEGLE = 'tac_tildig_v1';
  var MAKS_SET = 40, MAKS_SOEG = 10, ANTAL = 8, SOEG_ANTAL = 12;

  // Sektioner i temaet (nøglerne i templates/*.json). Nyheder er med vilje udeladt (Michael 31/10).
  var SEKTIONER_PR_BUTIK = {};
  SEKTIONER_PR_BUTIK.BT = {
    product: [
      { id: 'product-recommendations', liste: 'anbefalinger', venter: true },
      { id: 'section_collection_kjh7Ak', liste: 'favoritter' },
      { id: 'section_collection_h837bK', liste: 'tilbud' },
      { id: 'section_collection_FtfEAV', liste: null }          // bestsellere: kun Dame/Herre-fanen
    ],
    index: [
      { id: 'section_collection_WrQKgU', liste: 'tilbud' },
      { id: 'section_collection_NjhTWE', liste: 'tilbud', forskudt: 8 },
      { id: 'section_collection_Jz9Aia', liste: 'anbefalinger', ellers: 'favoritter' }
    ]
  };
  // Copenhagen Bamboo (Venue 16). "Udvalgte dame-/herreprodukter" har fast køn.
  SEKTIONER_PR_BUTIK.CB = {
    product: [
      { id: 'product-recommendations', liste: 'anbefalinger', venter: true },
      { id: 'udvalgte_produkter', liste: 'favoritter' },
      { id: 'section_collection_mqWRhx', liste: null }          // pakker: kun Dame/Herre-fanen
    ],
    index: [
      { id: 'section_collection_83WRDz', liste: 'anbefalinger', ellers: 'favoritter' },
      { id: 'section_collection_KnxtfX', liste: 'tilbud' },
      { id: 'section_collection_cbdame', liste: 'favoritter', koen: 'D' },
      { id: 'section_collection_cbherre', liste: 'favoritter', koen: 'H' }
    ]
  };
  var SEKTIONER = SEKTIONER_PR_BUTIK[C.butik || 'BT'];
  var KORT = C.kort || 'bt-tildig-kort', SOEG_LINJE = C.soegLinje || 'bt-tildig-soeg';

  var FAMILIER = [
    ['trusse', /truss|g-streng|hipster|tanga|brief/], ['underbukser', /underbuks|boxer|trunk/],
    ['bh', /\bbh\b|bralette|top uden/], ['stroemper', /strømpe|sok|footies|tennis/],
    ['nat', /nat|pyjamas|morgenkåbe|kimono/], ['tshirt', /t-shirt|tshirt|polo/],
    ['top', /tank|top|undertrøje|singlet|underkjole/], ['sweat', /sweat|hoodie|cardigan|trøje/],
    ['bukser', /bukser|leggings|shorts|jogging/], ['seng', /lagen|sengetøj|pude|dyne|håndklæde/]
  ];

  // ---- samtykke og historik ---------------------------------------------------------
  function maaGemme() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (cp && cp.preferencesProcessingAllowed) return !!cp.preferencesProcessingAllowed();
      if (cp && cp.userCanBeTracked) return !!cp.userCanBeTracked();
    } catch (e) {}
    return false;
  }
  function laesHist() {
    try {
      var h = JSON.parse(localStorage.getItem(NOEGLE) || '{}');
      return { set: h.set || [], soeg: h.soeg || [], kurv: h.kurv || [] };
    } catch (e) { return { set: [], soeg: [], kurv: [] }; }
  }
  var hist = laesHist();
  function gem() {
    if (!maaGemme()) return;
    try { localStorage.setItem(NOEGLE, JSON.stringify(hist)); } catch (e) {}
  }
  function noter(type, vaerdi, maks) {
    var l = hist[type].filter(function (x) { return x !== vaerdi; });
    l.unshift(vaerdi);
    hist[type] = l.slice(0, maks);
    gem();
  }

  // ---- data -------------------------------------------------------------------------
  var D = null, ved = {}, vedHandle = {}, FAM_TIL = {}, TOP_SOEG = [];
  var dataLoeft = null;
  function hentData() {
    if (!dataLoeft) {
      dataLoeft = fetch(C.data, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
        var f = d.felter;
        D = d.p.map(function (r, i) {
          var o = { i: i };
          for (var k = 0; k < f.length; k++) o[f[k]] = r[k];
          o.fam = o.fam || familie(o.kat + ' ' + o.titel);
          ved[o.id] = o; vedHandle[o.handle] = o;
          return o;
        });
        FAM_TIL = d.famTil || {};
        TOP_SOEG = d.topSoeg || [];
        // Prisniveau: varens pris i forhold til midten for dens slags (1 = normal)
        var priser = {};
        D.forEach(function (v) { (priser[v.fam] = priser[v.fam] || []).push(v.pris); });
        Object.keys(priser).forEach(function (f) { var l = priser[f].sort(function (a, b) { return a - b; }); priser[f] = l[l.length >> 1] || 1; });
        D.forEach(function (v) { v.prisRel = v.pris / (priser[v.fam] || v.pris || 1) || 1; });
        return D;
      });
    }
    return dataLoeft;
  }
  function familie(t) {
    t = (t || '').toLowerCase();
    for (var i = 0; i < FAMILIER.length; i++) if (FAMILIER[i][1].test(t)) return FAMILIER[i][0];
    return 'andet';
  }

  // ---- profil -----------------------------------------------------------------------
  function profil() {
    var p = { D: 0, H: 0, fam: {}, maerke: {}, frø: [] };
    var set = hist.set.slice();
    if (C.produkt && ved[C.produkt]) set = [C.produkt].concat(set.filter(function (x) { return x !== C.produkt; }));
    set.forEach(function (id, r) {
      var v = ved[id]; if (!v) return;
      var w = Math.pow(0.85, r) * (id === C.produkt ? 2 : 1);
      if (v.koen !== 'U') p[v.koen] += w;
      p.fam[v.fam] = (p.fam[v.fam] || 0) + w;
      p.maerke[v.maerke] = (p.maerke[v.maerke] || 0) + w;
      p.frø.push([v, w]);
    });
    // Lagt i kurven = har det allerede. Bruges til at forudsige det næste (det der købes ved siden af),
    // men den slags vises ikke igen. Kun set = interesseret, så der må gerne komme alternativer (højst 2).
    p.iKurv = {};
    hist.kurv.forEach(function (id) { var v = ved[id]; if (v) { p.frø.push([v, 1.5]); p.iKurv[v.fam] = 1; } });
    var k = (C.kollektion || '').toLowerCase();
    if (/dame|kvinde|hende/.test(k)) p.D += 3;
    if (/herre|maend|mænd|mand|ham\b/.test(k)) p.H += 3;
    p.koen = p.D > p.H * 1.5 && p.D > 0.5 ? 'D' : (p.H > p.D * 1.5 && p.H > 0.5 ? 'H' : null);
    p.koebt = {};
    p.koebtFam = {};
    (C.koebt || []).forEach(function (id) { if (id) { p.koebt[id] = 1; if (ved[id]) p.koebtFam[ved[id].fam] = 1; } });
    // Forudsig næste køb: hvad køber kunder, der har set/købt denne slags (fra alle ordrer, samme kurv og næste ordre).
    // Den slags kunden kigger på nu tæller halvt, så vi udfordrer med det, de typisk køber bagefter.
    p.forv = {};
    Object.keys(p.fam).forEach(function (f) {
      var til = FAM_TIL[f] || {};
      Object.keys(til).forEach(function (g) {
        p.forv[g] = (p.forv[g] || 0) + p.fam[f] * til[g] * (g === f ? 0.5 : 1);
        if (p.iKurv && p.iKurv[g]) p.forv[g] = 0;
      });
    });
    var maksForv = Math.max.apply(null, [0].concat(Object.keys(p.forv).map(function (g) { return p.forv[g]; }))) || 1;
    Object.keys(p.forv).forEach(function (g) { p.forv[g] /= maksForv; });
    p.famSum = Object.keys(p.fam).reduce(function (s, f) { return s + p.fam[f]; }, 0) || 1;
    // Prisfølsomhed: kigger kunden på billige eller dyre varer i forhold til deres slags?
    var ps = 0, pw = 0;
    p.frø.forEach(function (fw) { if (fw[0].prisRel) { ps += Math.log(fw[0].prisRel) * fw[1]; pw += fw[1]; } });
    p.prisNiveau = pw ? Math.exp(ps / pw) : null;
    p.maerkeSum = Object.keys(p.maerke).reduce(function (s, f) { return s + p.maerke[f]; }, 0) || 1;
    return p;
  }
  // En sektion med køn i overskriften eller fanen (2/11, Michael): kun varer til det køn, aldrig sengetøj.
  function koenOk(v, p) {
    if (p.kunKoen) return v.fam !== 'seng' && (v.koen === 'U' || v.koen === p.kunKoen);
    return !p.koen || v.koen === 'U' || v.koen === p.koen;
  }
  function smag(v, p) {
    var pris = p.prisNiveau && v.prisRel ? Math.exp(-0.5 * Math.abs(Math.log(v.prisRel / p.prisNiveau))) : 1;
    return (1 + 2 * (p.forv[v.fam] || 0) + 0.5 * (p.maerke[v.maerke] || 0) / p.maerkeSum) * (0.6 + 0.4 * pris);
  }
  function popularitet(v) { return Math.log(2 + v.salg90); }

  // Regler for en liste: ingen vare eller titel to gange på siden; den slags i kurven vises ikke; den slags kunden
  // kigger på højst 2; den slags kunden har købt højst 1; kendes kønnet ikke, blandes dame og herre ikke.
  function vaelg(kandidater, n, udeluk, maksPrFam) {
    var ud = [], pr = {}, set = {}, laas = null;
    kandidater.sort(function (a, b) { return b[1] - a[1]; });
    for (var i = 0; i < kandidater.length && ud.length < n; i++) {
      var v = kandidater[i][0];
      if (set[v.id] || udeluk[v.id] || set['T:' + v.titel] || udeluk['T:' + v.titel]) continue;
      var loft = maksPrFam && (vaelg.kurv && vaelg.kurv[v.fam] ? 0 : (vaelg.set && vaelg.set[v.fam] ? Math.min(2, maksPrFam) : maksPrFam));
      if (loft && vaelg.koebt && vaelg.koebt[v.fam]) loft = 1;
      if (maksPrFam && loft === 0) continue;
      if (loft && (pr[v.fam] || 0) >= loft) continue;
      if (!vaelg.koen && v.koen !== 'U') { if (laas && laas !== v.koen) continue; laas = v.koen; }
      set[v.id] = 1; set['T:' + v.titel] = 1; pr[v.fam] = (pr[v.fam] || 0) + 1; ud.push(v);
    }
    return ud;
  }
  function markerVist(l) { (l || []).forEach(function (v) { vist[v.id] = 1; vist['T:' + v.titel] = 1; }); }
  var vist = {};  // varer der allerede står i en anden sektion på siden
  function grundUdeluk(p) {
    var u = Object.assign({}, vist);
    if (C.produkt) u[C.produkt] = 1;
    Object.keys(p.koebt).forEach(function (id) { u[id] = 1; });
    return u;
  }

  var LISTER = {
    anbefalinger: function (p) {
      if (!p.frø.length) return null;
      var score = {};
      function add(v, s) { if (v && v.lager > 0 && koenOk(v, p)) score[v.id] = (score[v.id] || 0) + s; }
      p.frø.forEach(function (fw) {
        var f = fw[0], w = fw[1];
        // Motorens forbindelser: [vare, styrke 1-100], lært af ordrer, kunder der ligner og adfærd i butikken
        f.samkoeb.forEach(function (js) { add(D[js[0]], w * js[1] / 100); });
        f.passer.forEach(function (j, r) { add(D[j], w * 0.8 / (1 + r * 0.3)); });
      });
      var udeluk = grundUdeluk(p);
      p.frø.forEach(function (fw) { udeluk[fw[0].id] = 1; });
      var k = Object.keys(score).map(function (id) { var v = ved[id]; return [v, score[id] * smag(v, p) * Math.sqrt(v.trend || 1) * Math.pow(v.konv || 1, 0.3)]; });
      // Motorens forbindelser først. Har varen for få (nye varer, varer der sælger lidt), fyldes der op med det,
      // kunden forventes at købe bagefter (slags -> slags), i kundens køn, efter salg og tendens.
      var top = k.reduce(function (m, x) { return Math.max(m, x[1]); }, 0) || 1;
      k = k.map(function (x) { return [x[0], 10 + x[1] / top]; });
      var fyld = D.filter(function (v) { return v.lager > 0 && koenOk(v, p) && !score[v.id]; })
        .map(function (v) { return [v, popularitet(v) * smag(v, p) * Math.sqrt(v.trend || 1) * Math.pow(v.konv || 1, 0.3)]; });
      var fmax = fyld.reduce(function (m, x) { return Math.max(m, x[1]); }, 0) || 1;
      return vaelg(k.concat(fyld.map(function (x) { return [x[0], 0.99 * x[1] / fmax]; })), ANTAL, udeluk, 3);
    },
    favoritter: function (p) {
      if (!p.koen && !p.frø.length) return null;
      var k = D.filter(function (v) { return v.lager > 0 && koenOk(v, p); })
        .map(function (v) { return [v, popularitet(v) * smag(v, p) * Math.sqrt(v.trend || 1) * Math.pow(v.konv || 1, 0.3)]; });
      return vaelg(k, ANTAL, grundUdeluk(p), 2);
    },
    tilbud: function (p, forskudt) {
      if (!p.koen && !p.frø.length) return null;
      var k = D.filter(function (v) { return v.rabat > 0 && v.lager > 0 && koenOk(v, p); })
        .map(function (v) { return [v, popularitet(v) * smag(v, p) * Math.sqrt(v.trend || 1) * Math.pow(v.konv || 1, 0.3) * (1 + v.rabat / 100)]; });
      var l = vaelg(k, ANTAL + (forskudt || 0), grundUdeluk(p), 2);
      return l.slice(forskudt || 0);
    }
  };

  // ---- kort fra temaet --------------------------------------------------------------
  var kortCache = {};
  function hentKort(handle, sektion) {
    var n = sektion + ':' + handle;
    if (!kortCache[n]) {
      kortCache[n] = fetch(C.root.replace(/\/$/, '') + '/products/' + handle + '?section_id=' + sektion)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var t = document.createElement('div'); t.innerHTML = html;
          var s = t.querySelector('.shopify-section') || t;
          return s.firstElementChild ? s : null;
        }).catch(function () { return null; });
    }
    return kortCache[n];
  }

  function sektionEl(id) {
    return document.querySelector('[id$="__' + id + '"].shopify-section, #shopify-section-' + id);
  }
  function koenAfTekst(t) {
    t = (t || '').toLowerCase();
    if (/dame|hende|kvinde|kvinna|damen|women/.test(t)) return 'D';
    if (/herre|ham\b|mænd|maend|herr|men\b/.test(t)) return 'H';
    return null;
  }
  // Fanerne er temaets egne komponenter; de skal være klar, før et klik virker.
  function vaelgFane(el, koen) {
    var knapper = el.querySelectorAll('tab-triggers [role="tab"]');
    if (!koen || !knapper.length) return Promise.resolve();
    var klar = window.customElements ? customElements.whenDefined('tab-triggers') : Promise.resolve();
    var vent = new Promise(function (ok) { setTimeout(ok, 5000); });
    return Promise.race([klar, vent]).then(function () {
      for (var i = 0; i < knapper.length; i++) {
        if (koenAfTekst(knapper[i].textContent) === koen) {
          if (knapper[i].getAttribute('aria-selected') !== 'true') knapper[i].click();
          return;
        }
      }
    });
  }
  // Køn på den fane der vises nu; null hvis sektionen ikke har Dame/Herre-faner.
  function faneKoen(el) {
    var knapper = Array.prototype.slice.call(el.querySelectorAll('tab-triggers [role="tab"]'));
    var valgt = knapper.filter(function (k) { return k.getAttribute('aria-selected') === 'true'; })[0] || knapper[0];
    return valgt ? koenAfTekst(valgt.textContent) : null;
  }
  function aktivBeholder(el) {
    var panel = el.querySelector('tab-panel:not([hidden])') || el;
    return panel.querySelector('[data-items]');
  }

  function udskiftKort(el, liste, navn) {
    var beholder = aktivBeholder(el);
    if (!beholder || !liste || liste.length < 4) return Promise.resolve(false);
    markerVist(liste);
    return Promise.all(liste.map(function (v) { return hentKort(v.handle, KORT); })).then(function (kort) {
      var nye = kort.filter(Boolean).map(function (s) { return s.firstElementChild.cloneNode(true); });
      if (nye.length < 4) return false;
      nye.forEach(function (k) { k.setAttribute('data-tildig', navn); });
      beholder.replaceChildren.apply(beholder, nye);
      el.setAttribute('data-tildig', navn);
      window.dispatchEvent(new Event('resize'));
      return true;
    });
  }

  function naarFindes(el, sel, fn) {
    if (el.querySelector(sel)) return fn();
    var mo = new MutationObserver(function () {
      if (el.querySelector(sel)) { mo.disconnect(); fn(); }
    });
    mo.observe(el, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  // IntersectionObserver + et tjek ved scroll som reserve (nogle browsere fyrer ikke IO i baggrundsfaner)
  function naarSynlig(el, fn) {
    var gjort = false, io = null;
    function koer() { if (gjort) return; gjort = true; if (io) io.disconnect(); document.removeEventListener('scroll', tjek, true); fn(); }
    function tjek() { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight + 600 && r.bottom > -600) koer(); }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (e) { if (e.some(function (x) { return x.isIntersecting; })) koer(); }, { rootMargin: '600px 0px' });
      io.observe(el);
    }
    document.addEventListener('scroll', tjek, { passive: true, capture: true });  // også temaer der ruller i en boks
    tjek();
  }

  // "Passer godt sammen med": Shopify henter selv de 8; vi sorterer dem efter kunden.
  function sorterPasser(p) {
    var el = document.getElementById('complementary-products');
    if (!el) return;
    naarFindes(el, '[data-items] > *', function () {
      var b = el.querySelector('[data-items]');
      var kort = Array.prototype.slice.call(b.children);
      var maal = kort.map(function (k, r) {
        var a = k.querySelector('a[href*="/products/"]');
        var h = a && (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0];
        var v = h && vedHandle[h];
        // Andre slags først: samme slags som varen tæller halvt, den slags i kurven næsten intet
        var s = v ? (koenOk(v, p) ? 1 : 0.4) * smag(v, p) * (ved[C.produkt] && v.fam === ved[C.produkt].fam ? 0.5 : 1) *
          (p.iKurv && p.iKurv[v.fam] ? 0.1 : 1) : 1;
        return [k, s - r * 0.01];
      });
      maal.sort(function (x, y) { return y[1] - x[1]; });
      maal.forEach(function (m) { b.appendChild(m[0]); });
    });
  }

  function personaliser() {
    var p = profil();
    vaelg.set = p.fam; vaelg.kurv = p.iKurv; vaelg.koebt = p.koebtFam; vaelg.koen = p.koen;
    var liste = SEKTIONER[C.skabelon] || [];
    if (C.produkt && ved[C.produkt]) markerVist(ved[C.produkt].passer.map(function (j) { return D[j]; }).concat([ved[C.produkt]]));
    var status = window.__tacTildigStatus = [];
    liste.forEach(function (s) {
      var el = sektionEl(s.id);
      var st = { id: s.id, fundet: !!el };
      status.push(st);
      if (!el) return;
      // Listen regnes ud med det samme (i sidens rækkefølge), så to sektioner ikke viser de samme varer.
      var ps = p, fane = faneKoen(el), fast = s.koen || (fane && (p.koen || (p.frø.length ? fane : null)));
      if (fast) { ps = Object.assign({}, p, { koen: fast, kunKoen: fast }); vaelg.koen = fast; }
      var l = s.liste ? LISTER[s.liste](ps, s.forskudt) : null;
      if (!l && s.ellers) l = LISTER[s.ellers](ps, s.forskudt);
      vaelg.koen = p.koen;
      st.antal = l ? l.length : 0;
      markerVist(l);
      // Kortene hentes først, når kunden nærmer sig sektionen (600 px før), så siden ikke bliver tungere
      function koer() {
        vaelgFane(el, fast || p.koen).then(function () {
          st.fane = 1;
          if (l) naarSynlig(el, function () { st.synlig = 1; udskiftKort(el, l, s.liste).then(function (ok) { st.skiftet = ok; }); });
        });
      }
      if (s.venter) naarFindes(el, '[data-items]', koer); else koer();
    });
    if (C.skabelon === 'product') sorterPasser(p);
  }

  // ---- hændelser til motoren (kun med samtykke) --------------------------------------
  // Et tilfældigt id pr. browser, ingen navn, mail eller IP. Motoren lærer af det, hvilke varer der hænger sammen.
  var MOTOR = 'https://tac-feeds.onrender.com/motor/h';
  function besoegId() {
    if (!maaGemme()) return null;
    try {
      var id = localStorage.getItem('tac_tildig_id');
      if (!id) { id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4); localStorage.setItem('tac_tildig_id', id); }
      return id;
    } catch (e) { return null; }
  }
  var koe = [], koeTimer = null;
  function send(h, ekstra) {
    var id = besoegId();
    if (!id) return;
    var r = { v: id, h: h, b: C.butik || 'BT' };
    for (var k in ekstra) if (ekstra[k] != null) r[k] = ekstra[k];
    koe.push(r);
    clearTimeout(koeTimer);
    koeTimer = setTimeout(toem, 1500);
  }
  function toem() {
    if (!koe.length) return;
    var krop = JSON.stringify(koe.splice(0, 20));
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(MOTOR, new Blob([krop], { type: 'text/plain' })))) {
        oFetch(MOTOR, { method: 'POST', body: krop, keepalive: true, mode: 'no-cors' }).catch(function () {});
      }
    } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') toem(); });

  // ---- måling: hvilken sektion førte til køb ----------------------------------------
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-tildig]');
    if (!k || !e.target.closest('a[href*="/products/"]')) return;
    try { sessionStorage.setItem('tac_tildig_kilde', k.getAttribute('data-tildig')); } catch (x) {}
    var a = e.target.closest('a[href*="/products/"]'), h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0];
    var v = vedHandle[decodeURIComponent(h)];
    send('klik', { p: v && v.id, s: k.getAttribute('data-tildig') });
  }, true);
  // Kurven får besøgs-id'et (kun med samtykke) og kilden. Begge følger med ordren som skjulte attributter,
  // så motoren kan lære hvilke klik der endte i køb.
  function markerKurv() {
    var kilde = null, attr = {}, id = besoegId();
    try { kilde = sessionStorage.getItem('tac_tildig_kilde'); } catch (x) {}
    if (kilde) attr._tac_tildig = kilde;
    if (id) attr._tac_v = id;
    if (!kilde && !id) return;
    setTimeout(function () {   // efter at varen er lagt i, så kurven findes
      oFetch(C.root.replace(/\/$/, '') + '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attr })
      }).catch(function () {});
    }, 800);
  }

  // Læg i kurv: noteres i historikken (så "til dig" følger med) og markeres med kilden.
  var oFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      if (C.produkt) { noter('kurv', C.produkt, 10); send('lagt', { p: C.produkt }); }
      markerKurv();
    }
    if (/\/search\/suggest/.test(url) && /section_id=predictive-search/.test(url)) return soegForslag(url, init);
    return oFetch(input, init);
  };

  // ---- søgning ----------------------------------------------------------------------
  var SYNONYMER = {
    boxer: ['underbukser'], boxershorts: ['underbukser'], trunks: ['underbukser'], underbuks: ['underbukser'],
    trusse: ['trusser'], truser: ['trusser'], trusser: ['trusser'], tanga: ['g-streng', 'trusser'], thong: ['g-streng'],
    sok: ['strømper'], sokker: ['strømper'], strompe: ['strømper'], strømpe: ['strømper'], strømper: ['strømper'], socks: ['strømper'],
    bra: ['bh'], bh: ['bh'], undertøj: ['underbukser', 'trusser', 'bh'], undertoej: ['underbukser', 'trusser', 'bh'],
    pyjamas: ['nattøj'], pyjama: ['nattøj'], natkjole: ['natkjoler'], natdragt: ['nattøj'],
    tshirt: ['t-shirt'], 'tee': ['t-shirt'], trøje: ['t-shirt', 'sweatshirt'], hættetrøje: ['hoodie'],
    lagen: ['lagen'], dyne: ['sengetøj'], sengesæt: ['sengetøj'], dynebetræk: ['sengetøj'],
    sort: ['sort'], hvid: ['hvid'], blaa: ['blå'], graa: ['grå'], dame: ['dame'], herre: ['herre'], mand: ['herre'], kvinde: ['dame']
  };
  var KOEN_ORD = { D: 'dame damer kvinde kvinder hende women dam damen', H: 'herre herrer mand mænd ham men herr herren' };
  var indeks = null;
  function ordAf(t) {
    return (t || '').toLowerCase().normalize('NFKC').split(/[^0-9a-zæøåäöüß]+/).filter(function (w) { return w.length > 1; });
  }
  function bygIndeks() {
    if (indeks) return indeks;
    var ordTil = {};
    D.forEach(function (v) {
      var koenOrd = v.koen === 'D' ? KOEN_ORD.D : (v.koen === 'H' ? KOEN_ORD.H : KOEN_ORD.D + ' ' + KOEN_ORD.H);
      ordAf(v.soeg + ' ' + v.titel + ' ' + v.handle.replace(/-/g, ' ') + ' ' + koenOrd).forEach(function (w) {
        (ordTil[w] = ordTil[w] || {})[v.i] = 1;
      });
    });
    indeks = { ordTil: ordTil, ord: Object.keys(ordTil) };
    return indeks;
  }
  function afstand(a, b, maks) {
    if (Math.abs(a.length - b.length) > maks) return maks + 1;
    var p = [], c, i, j;
    for (j = 0; j <= b.length; j++) p[j] = j;
    for (i = 1; i <= a.length; i++) {
      c = [i]; var min = i;
      for (j = 1; j <= b.length; j++) {
        c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (min > c[j]) min = c[j];
      }
      if (min > maks) return maks + 1;
      p = c;
    }
    return p[b.length];
  }
  // Hvert søgeord giver {varer: {idx: point}, bedste: rettet ord}. Stavefejl-rettelsen bruges kun,
  // når ordet ikke findes (helt, som begyndelse eller inde i et ord), så "lagen" ikke bliver til "langen".
  function matchOrd(q) {
    var ix = bygIndeks();
    var maks = q.length >= 7 ? 2 : (q.length >= 4 ? 1 : 0);
    var maal = [q].concat(SYNONYMER[q] ? SYNONYMER[q].map(ordAf).reduce(function (a, b) { return a.concat(b); }, []) : []);
    var direkte = [], fejl = [];
    ix.ord.forEach(function (w) {
      var pt = 0;
      maal.forEach(function (m, n) {
        var s = 0;
        if (w === m) s = 1;
        else if (w.indexOf(m) === 0) s = 0.85;
        else if (m.length >= 4 && w.indexOf(m) > 0) s = 0.6;
        if (n > 0) s *= 0.9;
        if (s > pt) pt = s;
      });
      if (pt) direkte.push([w, pt]);
      else if (maks && afstand(q, w, maks) <= maks) fejl.push([w, 0.7]);
    });
    var brug = direkte.length ? direkte : fejl;
    var varer = {}, bedste = null, bedstePoint = 0, bedsteAntal = 0;
    brug.forEach(function (wp) {
      var w = wp[0], pt = wp[1], ids = Object.keys(ix.ordTil[w]);
      if (pt > bedstePoint || (pt === bedstePoint && ids.length > bedsteAntal)) { bedste = w; bedstePoint = pt; bedsteAntal = ids.length; }
      ids.forEach(function (i) { if (!varer[i] || varer[i] < pt) varer[i] = pt; });
    });
    // Rettet ord til søgesiden: stavefejl rettes; et synonym bruges kun når der er ét entydigt.
    var rettet = ix.ordTil[q] ? q : (!direkte.length || (SYNONYMER[q] && SYNONYMER[q].length === 1) ? bedste : q);
    return { varer: varer, bedste: rettet, fundet: brug.length > 0 };
  }
  function soeg(q, n) {
    var ord = ordAf(q);
    if (!ord.length) return { varer: [], rettet: q };
    var m = ord.map(matchOrd), p = profil();
    ord.forEach(function (w) {
      if (KOEN_ORD.D.split(' ').indexOf(w) > -1) p.koen = 'D';
      if (KOEN_ORD.H.split(' ').indexOf(w) > -1) p.koen = 'H';
    });
    var samlet = null;
    m.forEach(function (x) {
      if (!x.fundet) return;
      if (!samlet) { samlet = Object.assign({}, x.varer); return; }
      var ny = {};
      Object.keys(samlet).forEach(function (i) { if (x.varer[i]) ny[i] = samlet[i] * x.varer[i]; });
      samlet = ny;
    });
    if (!samlet || !Object.keys(samlet).length) {  // ingen vare har alle ordene: tag den bedste delvise
      samlet = {};
      m.forEach(function (x) { Object.keys(x.varer).forEach(function (i) { samlet[i] = (samlet[i] || 0) + x.varer[i]; }); });
    }
    var liste = Object.keys(samlet).map(function (i) {
      var v = D[i];
      var s = samlet[i] * (1 + popularitet(v) / 4) * smag(v, p) * (koenOk(v, p) ? 1 : 0.5) * (v.lager > 0 ? 1 : 0.15);
      return [v, s];
    }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, n || 6).map(function (x) { return x[0]; });
    var rettet = m.map(function (x, k) { return x.fundet ? x.bedste : ord[k]; }).join(' ');
    return { varer: liste, rettet: rettet };
  }

  function soegForslag(url, init) {
    var u = new URL(url, location.origin);
    var q = u.searchParams.get('q') || '';
    return hentData().then(function () {
      var r = soeg(q, 6);
      if (r.rettet && r.rettet !== q.toLowerCase().trim()) u.searchParams.set('q', r.rettet);
      sidsteRettet = r.rettet;
      var tema = oFetch(u.toString(), init).then(function (svar) { return svar.text(); });
      var linjer = Promise.all(r.varer.map(function (v) { return hentKort(v.handle, SOEG_LINJE); }));
      return Promise.all([tema, linjer]).then(function (res) {
        var html = indsaetLinjer(res[0], res[1].filter(Boolean));
        return new Response(html, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
      });
    }).catch(function () { return oFetch(url, init); });
  }
  var sidsteRettet = null;
  function indsaetLinjer(html, linjer) {
    if (!linjer.length) return html;
    var t = document.createElement('div'); t.innerHTML = html;
    var ul = t.querySelector('#predictive-search-results-list');
    if (!ul) {
      var paneler = t.querySelector('.predictive-search__panels');
      var rod = t.querySelector('#predictive-search-results');
      if (!rod) return html;
      if (!paneler) { paneler = document.createElement('div'); paneler.className = 'predictive-search__panels'; rod.prepend(paneler); }
      var panel = document.createElement('div');
      panel.className = 'predictive-search__panel predictive-search__panel--products';
      panel.innerHTML = '<ul id="predictive-search-results-list" class="predictive-search__results-list o-list-bare" role="listbox"></ul>';
      paneler.appendChild(panel);
      paneler.classList.add('predictive-search__panels--has-products');
      rod.classList.add('has-results');
      ul = panel.querySelector('ul');
    }
    var nye = linjer.map(function (s, k) {
      var li = s.querySelector('li').cloneNode(true);
      li.id = 'predictive-search-product-' + (k + 1);
      li.setAttribute('data-tildig', 'soeg');
      return li;
    });
    ul.replaceChildren.apply(ul, nye);
    var paneler2 = t.querySelector('.predictive-search__panels');
    if (paneler2) paneler2.className = paneler2.className.replace(/has-products-\d+/, '') + ' has-products-' + nye.length;
    return t.innerHTML;
  }

  // ---- søgeboksen før kunden skriver: "Til dig" + mest søgte (enkel udgave af Bambunis Clerk-søgning) ----
  function tilDigSoeg() {
    var p = profil();
    vaelg.set = p.fam; vaelg.kurv = p.iKurv; vaelg.koebt = p.koebtFam; vaelg.koen = p.koen;
    var gem = vist; vist = {};
    try {
      // 12 varer: anbefalinger, så favoritter, så det der sælger mest nu (højst 2-3 af hver slags)
      var l = [];
      [p.frø.length && LISTER.anbefalinger, (p.koen || p.frø.length) && LISTER.favoritter, LISTER.tilbud].forEach(function (f) {
        if (!f || l.length >= SOEG_ANTAL) return;
        markerVist(l);
        l = l.concat(f(p) || []);
      });
      if (l.length < SOEG_ANTAL) {
        markerVist(l);
        l = l.concat(vaelg(D.filter(function (v) { return v.lager > 0 && !vist[v.id]; }).map(function (v) {
          return [v, popularitet(v) * Math.sqrt(v.trend || 1)]; }), SOEG_ANTAL - l.length, vist, 3));
      }
      return l.slice(0, SOEG_ANTAL);
    } finally { vist = gem; }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fyldSoegeboks(boks) {
    if (boks.querySelector('.bt-tildig-tom')) return;
    var input = boks.querySelector('.js-search-input'), indhold = boks.querySelector('.js-search-content .search__content');
    if (!input || !indhold) return;
    if (!document.getElementById('bt-tildig-css')) {
      var st = document.createElement('style');
      st.id = 'bt-tildig-css';
      st.textContent = '.bt-tildig-tom{margin-top:24px}.bt-tildig-tom .search__nav{margin-bottom:24px}' +
        '.bt-tildig-tom .predictive-search__results-list{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:12px 24px}' +
        '.bt-tildig-tom .predictive-search__item{display:flex;align-items:center;gap:14px}' +
        '.bt-tildig-tom .o-ratio{flex:0 0 72px;width:72px}' +
        '.bt-tildig-tom .search__nav-items{display:flex;flex-wrap:wrap;gap:8px}' +
        '.bt-tildig-tom .search__nav-item a{display:inline-block;padding:6px 12px;border:1px solid rgba(0,0,0,.15);border-radius:20px}';
      document.head.appendChild(st);
    }
    var tom = document.createElement('div');
    tom.className = 'bt-tildig-tom';
    tom.setAttribute('data-tildig', 'soeg');
    indhold.appendChild(tom);
    function vis() { tom.hidden = !!input.value.trim(); }
    input.addEventListener('input', vis);
    hentData().then(function () {
      var ord = (TOP_SOEG.length ? TOP_SOEG : []).slice(0, 8);
      var html = '';
      if (ord.length) {
        html += '<div class="search__nav"><h4 class="search__nav-title f-family--body f-caps--false f-space--2">' +
          (koenTekst('mest') ) + '</h4><ul class="search__nav-items o-list-bare">' +
          ord.map(function (q) { return '<li class="search__nav-item"><a href="' + esc(C.root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(q)) + '">' + esc(q) + '</a></li>'; }).join('') + '</ul></div>';
      }
      html += '<div class="search__nav bt-tildig-tom__varer"><h4 class="search__nav-title f-family--body f-caps--false f-space--2">' + koenTekst('tildig') +
        '</h4><ul class="predictive-search__results-list o-list-bare"></ul></div>';
      tom.innerHTML = html;
      var ul = tom.querySelector('.bt-tildig-tom__varer ul');
      return Promise.all(tilDigSoeg().map(function (v) { return hentKort(v.handle, SOEG_LINJE); })).then(function (linjer) {
        linjer.filter(Boolean).forEach(function (sek) { var li = sek.querySelector('li'); if (li) ul.appendChild(li.cloneNode(true)); });
        vis();
      });
    }).catch(function () {});
  }
  var TEKSTER = {
    da: { mest: 'Mest søgte', tildig: 'Til dig' }, sv: { mest: 'Mest sökta', tildig: 'För dig' },
    de: { mest: 'Meistgesucht', tildig: 'Für dich' }, en: { mest: 'Most searched', tildig: 'For you' }
  };
  function koenTekst(n) { var l = (window.Shopify && Shopify.locale || 'da').slice(0, 2); return (TEKSTER[l] || TEKSTER.da)[n]; }
  // Søgeboksen fyldes, første gang kunden åbner den (klik på luppen eller fokus i feltet)
  document.addEventListener('focusin', function (e) {
    var boks = e.target.closest && e.target.closest('predictive-search');
    if (boks && e.target.matches('.js-search-input')) fyldSoegeboks(boks);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('a[href*="/search"], button, [data-search-toggle], .js-search-toggle')) return;
    setTimeout(function () { document.querySelectorAll('predictive-search').forEach(function (b) { if (b.offsetParent) fyldSoegeboks(b); }); }, 300);
  });

  // Enter i søgefeltet: send den rettede søgning videre, så søgesiden også finder noget ved stavefejl.
  document.addEventListener('submit', function (e) {
    var f = e.target, inp = f && f.querySelector && f.querySelector('input[name="q"]');
    if (!inp || !/\/search/.test(f.getAttribute('action') || '')) return;
    var q = inp.value.trim();
    if (q) { noter('soeg', q.toLowerCase(), MAKS_SOEG); send('soeg', { q: q.toLowerCase().slice(0, 60) }); toem(); }
    if (D && q) {
      var r = soeg(q, 1);
      if (r.rettet && r.rettet !== q.toLowerCase()) inp.value = r.rettet;
    }
  }, true);

  // Til test: hvilke lister får en kunde med denne historik? (ændrer intet på siden)
  window.__tacTildigLister = function (produkt, set, kurv, koebt, kunKoen) {
    return hentData().then(function () {
      var gemC = { produkt: C.produkt, koebt: C.koebt }, gemH = hist, gemVist = vist;
      C.produkt = produkt || null; C.koebt = koebt || [];
      hist = { set: set || [], soeg: [], kurv: kurv || [] }; vist = {};
      try {
        var p = profil();
        if (kunKoen) { p.koen = kunKoen; p.kunKoen = kunKoen; }
        vaelg.set = p.fam; vaelg.kurv = p.iKurv; vaelg.koebt = p.koebtFam; vaelg.koen = p.koen;
        if (C.produkt && ved[C.produkt]) markerVist(ved[C.produkt].passer.map(function (j) { return D[j]; }).concat([ved[C.produkt]]));
        var ud = { koen: p.koen, forv: p.forv };
        ['anbefalinger', 'favoritter', 'tilbud'].forEach(function (n) {
          var l = LISTER[n](p);
          markerVist(l);
          ud[n] = l ? l.map(function (v) { return { id: v.id, titel: v.titel, koen: v.koen, fam: v.fam, lager: v.lager, rabat: v.rabat }; }) : null;
        });
        return ud;
      } finally { C.produkt = gemC.produkt; C.koebt = gemC.koebt; hist = gemH; vist = gemVist; }
    });
  };
  window.__tacTildigData = function () { return hentData(); };

  window.__tacTildigSoeg = function (q) { return hentData().then(function () { var r = soeg(q, 8); return { rettet: r.rettet, varer: r.varer.map(function (v) { return v.titel; }) }; }); };

  // ---- start ------------------------------------------------------------------------
  function start() {
    if (C.produkt) { noter('set', C.produkt, MAKS_SET); sendSet(); }
    if (!SEKTIONER[C.skabelon]) { if (C.skabelon !== 'search') return; }
    hentData().then(function () {
      if (C.produkt) noter('set', C.produkt, MAKS_SET);
      personaliser();
    }).catch(function (e) { if (window.console) console.warn('TAC Til dig:', e); });
  }
  // Samtykket kan komme efter siden er indlæst: så gemmes det der allerede er set på denne side.
  var setSendt = false;
  function sendSet() { if (C.produkt && !setSendt && maaGemme()) { setSendt = true; send('set', { p: C.produkt }); } }
  function samtykke() { gem(); sendSet(); }
  document.addEventListener('visitorConsentCollected', samtykke);
  if (window.Shopify && Shopify.loadFeatures && !(Shopify.customerPrivacy)) {
    try { Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], samtykke); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
